import {
    ClockCircleOutlined,
    PlayCircleOutlined,
    CheckCircleOutlined,
    ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Card, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import Api from "../../../services/api";

const { Text, Title } = Typography;

const QuickActionCards = () => {
    const [counts, setCounts] = useState({
        late: 0,
        open: 0,
        done: 0,
        approval: 0,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await Api.get("/DashboardCustomFlowy/getCountTasks");
                setCounts(data.response); // assume que `response` já tem as chaves em minúsculo
            } catch (err) {
                console.error("Erro ao buscar contagem de tarefas", err);
            }
        };

        fetchData();
    }, []);

    const quickActions = [
        {
            key: "late",
            title: "Tarefas Atrasadas",
            getDescription: (v) => `${v} tarefas com prazo vencido`,
            icon: ExclamationCircleOutlined,
            color: "#f87171",
        },
        {
            key: "open",
            title: "Tarefas em Andamento",
            getDescription: (v) => `${v} em execução ou pendentes`,
            icon: PlayCircleOutlined,
            color: "#60a5fa",
        },
        {
            key: "approval",
            title: "Tarefas de Aprovação",
            getDescription: (v) => `${v} aguardando sua aprovação`,
            icon: ClockCircleOutlined,
            color: "#facc15",
        },
        {
            key: "done",
            title: "Tarefas Concluídas",
            getDescription: (v) => `${v} finalizadas`,
            icon: CheckCircleOutlined,
            color: "#34d399",
        },
    ];

    return (
        <Row gutter={[8, 8]} wrap align="stretch">
            {quickActions.map((action, idx) => {
                const Icon = action.icon;
                const count = counts[action.key] ?? 0;

                return (
                    <Col xs={24} sm={12} md={8} lg={8} xl={6} key={idx} style={{ height: "100%" }}>
                        <Card
                            style={{
                                height: "100%",
                                minHeight: 100,
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <Icon style={{ fontSize: 28, color: action.color, marginRight: 12 }} />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Title
                                        level={5}
                                        style={{
                                            marginBottom: 4,
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {action.title}
                                    </Title>
                                    <Text
                                        type="secondary"
                                        style={{
                                            fontSize: 14,
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {action.getDescription(count)}
                                    </Text>
                                </div>
                            </div>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};

export default QuickActionCards;
